<style scoped>
</style>

<template lang="html">
	<div>
        <p v-if="message" v-html="message"></p>
        <input type="checkbox" v-on:change="handler" v-model="enabled">
    </div>
</template>

<script>
export default {
    props: ["articleId", "tag", "message"],
    data: {
        enabled: null
    },
    methods: {
        save: async function() {
            let response = await axios.put("/api/tags/" + this.articleId);
        },
        get: async function() {
            let response = await axios.put("/api/tags/" + this.articleId + "/");
        }
    },
    created() {
        this.get();
    },
    updated() {
        updateIFrameHeight();
    }
};
</script>
